export const MONTHLY_SIGHTINGS_TITLE = 'Sighting Activity';
